import { Close, Info, Logout, MenuBook, Print, TextSnippet } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, AppBar, Avatar, Box, Button, Card, CardContent, Chip, CircularProgress, Container, Dialog, DialogContent, DialogTitle, Divider, IconButton, Modal, Paper, Stack, TextField, Toolbar, Tooltip, Typography, makeStyles } from '@mui/material';
import React, { useContext, useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import endpoints from '../constants/endpoints';
import useFetch from '../hooks/useFetch';
import { toCurrency } from '../utils/helpers';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import Chart from './Chart';
import DetailInfo from './DetailInfo';
import OverpriceVariation from './OverpriceVariation';
import navbar_background from '../assets/navbar_background.svg';
import icon from '../assets/quanto_custa_logo.png';
import mpmg from '../assets/mpmg.png';
import gsi from '../assets/gsi.png';
import LogoCeat from "../assets/logo-ceat-branco.png"
import { Link as RouterLink } from 'react-router-dom';
import { filterMap } from '../pages/Results';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useApiRequest from '../services/apiRequest';


type Props = {
    open: boolean,
    onClose: (() => void)
}

function Detail({ open, onClose }: Props) {
    const { queryStringConverter} = useApiRequest();
    const { currentUser } = useContext(GlobalStateContext);
    const { currentPage, setCurrentPage } = useContext(GlobalStateContext);
    const { description, filters, searchType: search_type, countFilters } = useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(`${endpoints.CHARTS + `/${currentUser?.profile.username}`}${queryStringConverter({ search_type })}`, JSON.stringify({
        description: description,
        ...filters
    }), "POST")
    const { typedFilters, setTypedFilters } = useContext(GlobalStateContext);
    const { selectedRowsFacet, setSelectedRowsFacet } = useContext(GlobalStateContext);


    const componentRef = useRef<HTMLDivElement>(null)

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: description || "detalhamento",
        onAfterPrint: () => { }
    });

    const getChartData = () => {
        return data.charts;
    }

    const formatNumber = (n: number) => {
        if (n < 1e3) return n + "";
        if (n >= 1e3 && n < 1e6) return (n / 1e3).toFixed(1) + "K";
        if (n >= 1e6 && n < 1e9) return (n / 1e6).toFixed(1) + "M";
        if (n >= 1e9 && n < 1e12) return (n / 1e9).toFixed(1) + "B";
        if (n >= 1e12) return (n / 1e12).toFixed(1) + "T";
        return "";
    };

    const convertNumberToMonth = (numbers: number[]) => {
        const monthNames = [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
            "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ];

        let str = ""
        for (let i = 0; i < numbers.length; i++) {

            if (numbers[i] >= 1 && numbers[i] <= 12 && numbers[i] != +',') {
                str = str + monthNames[numbers[i] - 1] + ",";
            } else {
                str = str + monthNames[numbers[i] - 1] + ",";
            }

        }

        while (str.includes('undefined')) {
            str = str.replace('undefined,', '');
        }
        return str


    };

    const hasFacets = () => {
        const base_facet = filters.base_facet;
        const description_facet = filters.description_facet;
        const cluster_facet = filters.cluster_facet;
        const unit_metric_facet = filters.unit_metric_facet;
        const year_facet = filters.year_facet;
        const prd_serv_facet = filters.prd_serv_facet;
        const relevant_facet = filters.relevant_facet;
        const first_token_facet = filters.first_token_facet;

        if ((base_facet && base_facet.length > 0) || (description_facet && description_facet.length > 0) || (cluster_facet && cluster_facet.length > 0) || (unit_metric_facet && unit_metric_facet.length > 0) || (year_facet && year_facet.length > 0) || (prd_serv_facet && prd_serv_facet.length > 0) || (relevant_facet && relevant_facet.length > 0) || (first_token_facet && first_token_facet.length > 0)) {
            return true;
        } else {
            return false;
        }
    }

    const renderFilters = () => {

        const result: string[] = [];
        const filterArray = Object.entries(filters).filter(item => item[1])
        for (const f of filterArray) {
            const filterMapped = filterMap[f[0]]

            if (filterMapped) {
                var filterResult: string = ""
                f[1] = f[1] + "";
                if (filterMapped.showValue === true && f[1].length > 0) {
                    if (filterMapped.label == "Mês") {
                        filterResult = filterMapped.label + ": " + convertNumberToMonth(f[1]);
                        result.push(filterResult)
                    } else {
                        filterResult = filterMapped.label + ": " + f[1];
                        result.push(filterResult)
                    }

                }
            }


        }

        return (

            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                <Box sx={{ maxWidth: '90%' }}>
                    {
                        result.map(item => {

                            let label = item.split(":")[0];
                            let val = item.split(":")[1];
                            return (<Typography variant='h6' sx={{ m: 1 }}><b>{label}:</b> {val}; </Typography>)
                        })
                    }

                    {filters.skip_duplicates &&
                        <Typography variant='h6' sx={{ m: 1 }}><b>Remover duplicidades:</b> Sim; </Typography>
                    }

                </Box>
            </Stack>
        );
    }

    const renderFacets = () => {
        const base_facet = filters.base_facet;
        const description_facet = filters.description_facet;
        const cluster_facet = filters.cluster_facet;
        const unit_metric_facet = filters.unit_metric_facet;
        const year_facet = filters.year_facet;
        const prd_serv_facet = filters.prd_serv_facet;
        const relevant_facet = filters.relevant_facet;
        const first_token_facet = filters.first_token_facet;

        const joinFacet = (facet: any[]) => facet.join(", ");


        return (
            <Stack direction="row" sx={{ ml: 1, width: '100%', justifyContent: 'space-between' }}>
                <Box sx={{ maxWidth: '90%' }}>
                    {base_facet && base_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Fonte de Dados:</b> {joinFacet(base_facet)}; </Typography>}
                    {description_facet && description_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Descrição:</b> {joinFacet(description_facet)}; </Typography>}
                    {relevant_facet && relevant_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Descrição processada:</b> {joinFacet(relevant_facet)}; </Typography>}
                    {first_token_facet && first_token_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Primeiro termo:</b> {joinFacet(first_token_facet)}; </Typography>}
                    {cluster_facet && cluster_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Descrição automática:</b> {joinFacet(cluster_facet)}; </Typography>}
                    {unit_metric_facet && unit_metric_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Unidade de medida:</b> {joinFacet(unit_metric_facet)}; </Typography>}
                    {year_facet && year_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Ano:</b> {joinFacet(year_facet)}; </Typography>}
                    {prd_serv_facet && prd_serv_facet.length > 0 && <Typography variant='h6' sx={{ m: 1 }}><b>Serviço/Produto:</b> {joinFacet(prd_serv_facet)}; </Typography>}
                </Box>
            </Stack>
        )
    }

    function getCurrentDateTime(): string {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Os meses começam do 0, por isso adicionar 1
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        setCurrentPage(0);
    }, [open])



    const renderPrint = () => {
        return (
            <div ref={componentRef} className="print-content">
                <AppBar position="static" color="primary" sx={{ backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Toolbar sx={{ justifyContent: 'space-between' }}>
                        <Typography variant='h6'>
                            <RouterLink className='flex flex-1' to="/"><img src={icon} style={{ height: "60px" }} />

                            </RouterLink>
                        </Typography>
                        <div className="flex flex-row mr-0">
                            <img src={mpmg} style={{ height: "45px" }} />
                            <img src={gsi} style={{ height: "45px" }} />
                            <img src={LogoCeat} style={{ height: "45px" }} />
                        </div>
                    </Toolbar>
                </AppBar>
                <Typography
                    variant='h3'
                    color={'primary'}
                    sx={{ marginBottom: 2, ml: 2, mt: 2, textAlign: 'center' }}
                >
                    Análise de Preço
                </Typography>
                <Container sx={{ mt: 4 }}>
                    <Paper sx={{
                        padding: 4,
                        borderRadius: 2,
                    }}
                        elevation={2}>
                        <Typography
                            variant='h5'
                            sx={{ marginBottom: 1 }}
                        >
                            Data: {getCurrentDateTime()}
                        </Typography>
                        <Typography
                            variant='h5'
                            sx={{ marginBottom: 2 }}
                        >
                            Descrição: {description}
                        </Typography>
                        {countFilters() > 0 || hasFacets() &&
                            <Typography
                                variant='h5'
                            >
                                Filtros: 
                                {renderFilters()}
                                {renderFacets()}
                            </Typography>
                        }



                    </Paper>
                </Container>
                <div className="mt-2">
                    <Container className="mt-2">
                        <Paper
                            sx={{
                                padding: 4,
                                borderRadius: 2,
                            }}>

                            {loading || !data
                                ? <div className='flex flex-col justify-center items-center'><CircularProgress /></div>
                                : <>
                                    <div className="my-1">
                                        <Typography variant='h4' sx={{ mb: 2 }}>Estatísticas gerais</Typography>

                                    </div>

                                    <div className=" grid grid-cols-5 gap-4">
                                        <DetailInfo number={formatNumber(data.statistics.count_item)} label='Total itens' color="bg-[#7E9EB8]" print={true} />
                                        <DetailInfo number={formatNumber(data.statistics.sum_qtde_item)} label='Total unidade' color="bg-[#30638E]" print={true} />
                                        <DetailInfo number={toCurrency(data.statistics.min)} label='Preço Mínimo' color="bg-[#6A994E]" print={true} />
                                        <DetailInfo number={toCurrency(data.statistics.avg)} label='Preço Médio' color="bg-[#EDAE49]" print={true} />
                                        <DetailInfo number={toCurrency(data.statistics.max)} label='Preço Máximo' color="bg-[#D1495B]" print={true} />
                                    </div>

                                    <div className='flex flex-col w-8/12 mx-auto py-3'>
                                        <Chart field="qtde_item" type='sum' color="#003D5B" label="Relação de Unidades" axisName='Qtd. de Unidades' data={getChartData()} print />
                                        <Chart field="mean_preco" type="avg" color="#386641" label="Relação de Preços" axisName='Preço' data={getChartData()} print />
                                    </div>
                                </>
                            }
                        </Paper>
                    </Container>
                    <Container className="mt-2">
                        <Paper
                            sx={{
                                padding: 3,
                                borderRadius: 2,
                            }}>

                            {loading || !data
                                ? <div className='flex flex-col justify-center items-center'><CircularProgress /></div>
                                : <>
                                    <div className="my-4 mx-2">
                                        <Typography variant='h4'>Variacação de preço</Typography>
                                        <OverpriceVariation
                                            min={data.statistics.min}
                                            max={data.statistics.max}
                                            q1={data.statistics.q1}
                                            q2={data.statistics.q2}
                                            q3={data.statistics.q3}
                                            avg={data.statistics.avg}
                                            threshold={data.statistics.upper}
                                            count_normal={data.statistics.count_normal}
                                            count_high={data.statistics.count_high}
                                            count_alert={data.statistics.count_alert}
                                            count_anomaly={data.statistics.count_anomaly}
                                            count_total={data.statistics.count_item}
                                            count_avg_below={data.statistics.count_avg_below}
                                            count_avg_above={data.statistics.count_avg_above}
                                            count_median_below={data.statistics.count_median_below}
                                            count_median_above={data.statistics.count_median_above}
                                            print={true}
                                        />

                                    </div>
                                </>
                            }
                        </Paper>
                        <Paper>

                            {loading || !data
                                ? <div className='flex flex-col justify-center items-center'><CircularProgress /></div>
                                : <>
                                </>
                            }
                        </Paper>
                    </Container>

                </div>

            </div>
        );
    }


    return (

        <>
            <style>{`
                @media print {
                    .print-content {
                        display: block;
                    }
                    .dialog-content {
                        display: none;
                    }
                }
                @media screen {
                    .print-content {
                        display: none;
                    }
                }
            `}</style>
            <div >
                {renderPrint()}
                <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth={false}>
                    <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                        <div className="flex flex-row">

                            <div className="basis-10/12">
                                <Typography variant='h4'>Análise de Preço</Typography>
                            </div>
                            <div className="basis-1/12">
                                <Button variant="contained" disabled={loading} onClick={handlePrint} color='inherit' sx={{color: '#00617b'}} startIcon={<Print />}>Imprimir</Button>
                            </div>
                            <div className="basis-1/12 text-right">
                                <IconButton onClick={onClose} >
                                    <Close sx={{ color: 'white' }} />
                                </IconButton>
                            </div>
                        </div>
                    </DialogTitle>
                    <DialogContent >
                        <Box className="mt-2"  >
                            <Container className="mt-2" sx={{ minWidth: '100%' }}>
                                <Paper sx={{ padding: 4, borderRadius: 2 }} elevation={2}>
                                    <Typography
                                        variant='h5'
                                        sx={{ marginBottom: 1 }}
                                    >
                                        Data: {getCurrentDateTime()}
                                    </Typography>
                                    <Typography
                                        variant='h5'
                                        sx={{ marginBottom: 1 }}
                                    >
                                        Descrição: {description}
                                    </Typography>
                                    {countFilters() > 0 || hasFacets() ?
                                        <Accordion >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                                sx={{ padding: 0.5, bgcolor: '#f5f5f5' }}
                                            >
                                                <Typography
                                                    variant='h5'
                                                >
                                                    Filtros
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                {renderFilters()}
                                                {countFilters() > 0 && <Divider />}
                                                {renderFacets()}
                                            </AccordionDetails>
                                        </Accordion>

                                        : <></>

                                    }


                                </Paper>
                            </Container>

                            <Container className="mt-2" sx={{ minWidth: '100%' }}>
                                <Paper sx={{ padding: 4, borderRadius: 2 }}>

                                    {loading || !data
                                        ? <div className='flex flex-col justify-center items-center'><CircularProgress /></div>
                                        : <>
                                            <div className="my-1">
                                                <Typography variant='h4'>Estatísticas gerais</Typography>
                                            </div>

                                            <div className="my-4 grid grid-cols-5 gap-4">
                                                <DetailInfo number={formatNumber(data.statistics.count_item)} label='Total itens' color="bg-[#7E9EB8]" />
                                                <DetailInfo number={formatNumber(data.statistics.sum_qtde_item)} label='Total unidade' color="bg-[#30638E]" />
                                                <DetailInfo number={toCurrency(data.statistics.min)} label='Preço Mínimo' color="bg-[#6A994E]" />
                                                <DetailInfo number={toCurrency(data.statistics.avg)} label='Preço Médio' color="bg-[#EDAE49]" />
                                                <DetailInfo number={toCurrency(data.statistics.max)} label='Preço Máximo' color="bg-[#D1495B]" />
                                            </div>


                                            <div className="my-4 grid grid-cols-2 gap-4">
                                                <Chart
                                                    field="qtde_item"
                                                    type='sum' color="#003D5B"
                                                    label="Relação de Unidades"
                                                    info="Somatório das quantidades de unidades dos itens adquiridos por mês / ano."
                                                    axisName='Somatório qtd. unidades'
                                                    data={getChartData()}
                                                    print={false} />


                                                <Chart
                                                    field="mean_preco"
                                                    type="avg"
                                                    color="#386641"
                                                    label="Relação de Preços"
                                                    info="Média dos preços praticados por mês / ano."
                                                    axisName='Preço médio'
                                                    data={getChartData()}
                                                    print={false} />
                                            </div>

                                        </>
                                    }

                                </Paper>
                            </Container>
                            <Container className="mt-2" sx={{ minWidth: '100%' }}>
                                <Paper sx={{ padding: 4, borderRadius: 2 }}>

                                    {loading || !data
                                        ? <div className='flex flex-col justify-center items-center'><CircularProgress /></div>
                                        : <>

                                            <div className="my-4">
                                                <Typography variant='h4'>Variação de preço</Typography>
                                                <OverpriceVariation
                                                    min={data.statistics.min}
                                                    q1={data.statistics.q1}
                                                    q2={data.statistics.q2}
                                                    q3={data.statistics.q3}
                                                    avg={data.statistics.avg}
                                                    max={data.statistics.max}
                                                    threshold={data.statistics.upper}
                                                    count_normal={data.statistics.count_normal}
                                                    count_high={data.statistics.count_high}
                                                    count_alert={data.statistics.count_alert}
                                                    count_anomaly={data.statistics.count_anomaly}
                                                    count_total={data.statistics.count_item}
                                                    count_avg_below={data.statistics.count_avg_below}
                                                    count_avg_above={data.statistics.count_avg_above}
                                                    count_median_below={data.statistics.count_median_below}
                                                    count_median_above={data.statistics.count_median_above}
                                                    print={false}
                                                />

                                            </div>

                                        </>
                                    }

                                </Paper>
                            </Container>
                        </Box>
                    </DialogContent>

                </Dialog>
            </div>
        </>

    );
}

export default Detail;
